import React,{ useState,useRef,useEffect,useCallback } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from 'react-i18next';
import { ReactTabulator } from 'react-tabulator';
import API from '../../api/api.jsx';
import { useLocation } from 'react-router-dom';

//기타,가족,관리영업직원 정보 칸  
const fixedTabSizeStyle = {        
    height: '300px',
    /* 다른 스타일도 필요한 경우 추가하세요 */
  };

// Tabulator columns 목록
const defaultFeeInfo= (t, feeInfoOptions) => {
	return [
		{ field: 'fee_id',visible:false },
		{ title: t('PREFERENCES.수수료명', { defaultValue: '수수료명' }), field: 'fee_name', headerHozAlign: 'center', hozAlign: 'center', width:200 },		
		{ title: t('PREFERENCES.수수료', { defaultValue: '수수료' }), field: 'fee', headerHozAlign: 'center', hozAlign: 'center', width: 150,editor: 'input' },
		{
			title: t('PREFERENCES.수수료정보', { defaultValue: '수수료정보' }),
			field: 'fee_type',
			headerHozAlign: 'center',
			hozAlign: 'center',
			width: 200,
			editor: 'list',
			editorParams: {
				values: feeInfoOptions.map(option => ({
					value: option[0],
					label: t(`${option[1]}.${option[0]}`, { defaultValue: option[0] }),
				})),
			},
			formatter: (cell) => {
				const value = cell.getValue();
				const matchedOption = feeInfoOptions.find(option => option[0] === value);
				return matchedOption ? t(`${matchedOption[1]}.${matchedOption[0]}`, { defaultValue: matchedOption[0] }) : value;
			},
		},
		{ title: t('PREFERENCES.회수처리순번', { defaultValue: '회수처리순번' }), field: 'sort_sn', headerHozAlign: 'center', hozAlign: 'center', width:150, },
	];
};

const Loan002_02 = ({ loan_application_id, loan_status }) => {
	const { t,i18n } 								  = useTranslation();
	const tableRef    								  = useRef(null);
	const location 									  = useLocation();	
	const params                                      = new URLSearchParams(location.search);
  	const loanApplicationId                           = params.get('loanApplicationId')
	
	const [saveBtn, setSaveBtn]       					= useState('수수료정보 저장');

	const [basicData, setBasicData]                   = useState([]);
	const [responseData, setResponseData]             = useState([]);
	const [hovered1, setHovered1]                     = useState(false);
	const [hovered2, setHovered2]                     = useState(false);

    const [feeInfoOptions, setFeeInfoOptions] = useState([]);
	const [defeecolumns, setColumns3]         = useState(defaultFeeInfo(t, feeInfoOptions));

	
	//저장버튼
	const handleMouseEnter1 = () => {
		setHovered1(true);
	};
    const handleMouseLeave1 = () => {
		setHovered1(false);
    };
	const buttonStyle1 = {
		backgroundColor: hovered1 ? '#286A45' : '#7DA390',
        color: '#FFFFFF', // 글자 색상
        /* 기타 스타일들... */
    };

	//갱신버튼
	const handleMouseEnter2 = () => {
		setHovered2(true);
	};
    const handleMouseLeave2 = () => {
        setHovered2(false);
    };
	const buttonStyle2 = {
        backgroundColor: hovered2 ? '#286A45' : '#7DA390',
        color: '#FFFFFF', // 글자 색상
        /* 기타 스타일들... */
    };

	// 조회 버튼 작동 시 실행되는 함수
	const handleQuery = async () => {	
		if (loanApplicationId) {
			setSaveBtn(t(`LOAN_APPLICATION.수수료정보 수정`, { defaultValue: '수수료정보 수정' }));
		}
		// API 호출 부분
		try {
			const data = await API.fetchLoan002Data({	
				'loanApplicationId' : loanApplicationId
			});

			setBasicData(data)

			// 전달받은 데이터 중 다국어에 따라 Tabulator에 번역이 되어 display되게 하는 부분
			const translatedData = data.map(item => ({
				...item,
				fee_type     : t(`FEE_TYPE.${item.fee_type}`, {defaultValue : `${item.fee_type}`}),				
			}));
			

			setResponseData(translatedData);
			// setLoading(false);
		} catch (error) {
			console.error('Error in fetchAcctDataUpdateState:', error);
		}
	};
	//수수료정보 저장
	const handleSave = async (e) => {	

		const allData = tableRef.current.getData(); // tabulator에 있는 data 전부 가져오기
		// const modifiedData = allData;
		// console.log('All Data with fee_type codes:', allData); // fee_type은 원래 코드 값(T03 등)으로 표시됨

		// basicData 배열을 사용하여 fee_type 값을 순차적으로 가져옴
		// const newFeeTypes = basicData.map(basicItem => basicItem.fee_type);
		// const newFeeTypes = basicData.map(basicItem => {
		// 	// console.log('basicItem :', basicItem); // 로그를 map 내부에서 실행
		// 	return basicItem.fee_type;
		// });
		// // console.log('basicItem :', basicItem);
		// console.log('newFeeTypes :', newFeeTypes);
		//  // allData의 각 요소에 접근하여 fee_type 값을 basicData의 fee_type 값으로 순차적으로 교체
		// const modifiedData = allData.map((data, index) => {
		// 	return {
		// 		...data,
		// 		fee_type: newFeeTypes[index],
		// 	};

		// });
		// console.log('modifiedData :', modifiedData);

		if(!allData){			
			alert('수수료가 존재 하지 않습니다.')
			return
		}else if(!loan_application_id && !loanApplicationId){	
			alert('대출정보가 존재하지 않아 승인요청 할 수 없습니다.')
		}else{					
			allData.map(async (item) => {
				//loanApplicationId를 담아서 보낸다
				if(!loan_application_id){
					item.loanApplicationId = loanApplicationId
				}else{
					item.loanApplicationId = loan_application_id
				}
			})
			try {
				const savedData = await API.fetchLoan00202DataPOST({
					allData : allData
				});
				
				alert(t(`LOAN_APPLICATION.수수료정보가 저장되었습니다`, { defaultValue: '수수료정보가 저장되었습니다' }));

				if (savedData.code === 201) {
				}
			}catch (error) {
				}   
		}
	};
	
	//수수료정보 갱신
	const handleRenewal  = async (e) => {

		
		if(!loan_application_id.loan_application_id && !loanApplicationId){	
			
			alert('대출정보가 존재하지 않아 승인요청 할 수 없습니다.')
			return
		}
		
		let send_application_id = ''
		
		if(!loan_application_id.loan_application_id){
			send_application_id = loanApplicationId
		}else{
			send_application_id = loan_application_id.loan_application_id
		}
		
		try {
			
			const renewalData = await API.fetchLoan00202Renewal({
				loan_application_id : send_application_id
			});
			
			setSaveBtn(t(`LOAN_APPLICATION.수수료정보 수정`, { defaultValue: '수수료정보 수정' }));
			alert('수수료정보가 갱신되었습니다.')
			
			handleQuery();

			if (renewalData.code === 201) {
			}
		}catch (error) {
			} 


	}
	useEffect(() => {
		const fetchBaseOptions = async () => {
			try {
				const data = await API.fetchBaseOptions();

				const options       = data.filter(item => item.code_nick_name === '수수료정보');
				const branchOptions = options.map(item => [item.code,item.code_se]);
				
				setFeeInfoOptions(branchOptions);

			} catch (error) {
				console.error('Error fetching data:', error);
			}
		};
		fetchBaseOptions();
	}, []); // 빈 배열은 컴포넌트가 마운트될 때 한 번만 실행

	// i18 언어에 맞춰서 자동 갱신 (컬럼명, Grid 내용)
	useEffect(() => {		
		setColumns3(defaultFeeInfo(t, feeInfoOptions))	
		handleQuery();	
	}, [i18n.language,t,loan_status]);

	// 화면 UI
	return (
		<div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordion">
			<div className="accordion-body bg-white text-gray-900 ">
				{/* Tabulator */}
				<ReactTabulator
					key={i18n.language + JSON.stringify(defeecolumns)}
					onRef={(r) => (tableRef.current = r.current)}
					columns={defeecolumns}
					data={responseData}
					options={{
						layout: "fitColumns",
						placeholder: "조회결과가 없습니다",
					}}
					className="responsive-tabulator"
				/>
					<div className = "p-1 pt-3 d-flex justify-content-center">
						{loan_status === '' || loan_status === 'S01' || loan_status ==='S04' || loan_status ==='S06'  ?(
							<button type="button" className="btn text-white" style={buttonStyle1} onMouseEnter={handleMouseEnter1} onMouseLeave={handleMouseLeave1} onClick={handleSave}>
								{t(`LOAN_APPLICATION.${saveBtn}`, { defaultValue: saveBtn })}
							</button>
						) : null}
					<div className="ml-2"></div> {/* 여백을 만들기 위한 빈 div */}
						{loan_status === '' || loan_status === 'S01' || loan_status ==='S04' || loan_status ==='S06' ?(
							<button type="button" className="btn text-white" style={{ ...buttonStyle2, marginLeft: '8px' }} onMouseEnter={handleMouseEnter2} onMouseLeave={handleMouseLeave2} onClick={handleRenewal}>
								{t('LOAN_APPLICATION.수수료정보 갱신', { defaultValue: '수수료정보 갱신' })}
							</button>
						) : null}
					</div>
			</div>							
		</div>
	);
};

export default Loan002_02;